// extracted by mini-css-extract-plugin
export default {"page":"subscriptions_page__pVMaV","container":"subscriptions_container__IbPrz","title":"subscriptions_title__p4EfZ","content":"subscriptions_content__-JHYO"};